import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getSessionCookies } from "@/lib/cookies";
import { useAppStore } from "@/store/app";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";

import logo from "@/assets/logo.svg";

interface IFormInput {
  username: string;
  password: string;
}

const schema = yup.object().shape({
  username: yup.string().required("Nome de usuário é obrigatório"),
  password: yup.string().required("Senha é obrigatória"),
});

export default function Login() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormInput>({
    resolver: yupResolver(schema),
  });
  const { login, loginWithToken } = useAppStore();

  function handleSignIn(data: IFormInput) {
    setLoading(true);
    doLogin(data);
  }

  function handleSignInError(error: any) {
    console.error(error);
  }

  const doLogin = useCallback(
    async (data: IFormInput) => {
      // setSession({ user: { name: "John Doe" } });
      try {
        await login(data);
        const redirect = params.get("redirect");

        if (redirect) {
          navigate(redirect);
        } else {
          navigate("/");
        }
      } catch (e) {
        console.log("login error", e);
      }
    },
    [navigate, params, login],
  );

  const doLoginWithToken = useCallback(
    async (token: string) => {
      try {
        await loginWithToken(token);
      } catch (e) {
        setLoading(false);
      }
    },
    [loginWithToken],
  );

  useEffect(() => {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");
      if (token) {
        doLoginWithToken(token);
      }
    } else {
      const session = getSessionCookies();
      if (session) {
        navigate("/");
      }
    }
  }, [navigate, doLoginWithToken]);

  return (
    <div className="flex flex-col gap-2 items-center justify-center h-screen">
      <img src={logo} alt="Funifier Logo" className="max-w-28" />
      <form
        onSubmit={handleSubmit(handleSignIn, handleSignInError)}
        className="flex flex-col gap-2 w-64"
      >
        <Input
          aria-invalid={errors.username ? "true" : "false"}
          className="aria-[invalid=true]:border-red-500"
          {...register("username")}
          placeholder="Usuário"
          type="text"
        />
        {errors.username?.message ? (
          <span
            role="alert"
            className="text-xs border-dashed border border-red-200 bg-red-100 text-red-400 px-2 py-2 mb-2 rounded"
          >
            {errors.username?.message}
          </span>
        ) : null}
        <Input
          aria-invalid={errors.username ? "true" : "false"}
          className="aria-[invalid=true]:border-red-500"
          {...register("password")}
          placeholder="Senha"
          type="password"
        />
        {errors.password?.message ? (
          <span
            role="alert"
            className="text-xs border-dashed border border-red-200 bg-red-100 text-red-400 px-2 py-2 mb-2 rounded"
          >
            {errors.password?.message}
          </span>
        ) : null}
        <Button type="submit" disabled={loading}>
          {loading ? "Please wait..." : "Login"}
        </Button>
        <small className="text-center text-gray-400">v0.1</small>
      </form>
    </div>
  );
}
